import * as actionTypes from "../../constants/actionTypes";

const initGlobalState = {
  loading: false,
  account: "",
  signature: "",
  balance: 0,

  error: null,
  errorMsg: "",
  errorTitle: "",
  errorBtnLabel: "",
  errorCallback: null,
  warning: {
    show: false,
    message: "",
  },
  poolFactory: "",
  corePoolContract: "",
  corePoolAddress: "",
  poolAddresses: {},
  poolContracts: {},
  tknSymbol: {},
  networkIdFromURL: "",
  projectNamePoolName: {},
  rewardDecimalPoolTokenDecimal: {},
  poolDetailsFromFactory: {},
  walletModal: {
    show: false,
  },
  currentChainId: null,
  etherCurPrice: 0,
  hasMetamask: !!window.web3, // to check if the user has metamask
  network: "Not Connected",
  web3Instance: {},
  isApproved: 0,
  realTimeValues: {},
  actionBasedData: {}
};

export const globalReducer = (state = initGlobalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.SET_NETWORK:
      return { ...state, network: payload.network };
    case actionTypes.SET_WEB3:
      return { ...state, web3Instance: payload.web3Instance };
    case actionTypes.SET_LOADING:
      return { ...state, loading: payload.loading };
    case actionTypes.SET_ACCOUNT_DETAILS:
      return {
        ...state,
        account: payload.account,
        signature: payload.signature,
        balance: payload.balance,
      };
    case actionTypes.SET_HAS_METAMASK:
      return { ...state, hasMetamask: payload.hasMetamask };
    case actionTypes.SET_ERROR:
      return {
        ...state,
        error: payload.error,
        errorMsg: payload.errorMsg,
        errorTitle: payload.errorTitle,
        errorBtnLabel: payload.errorBtnLabel,
        errorCallback: payload.errorCallback ?? null,
      };
    case actionTypes.SET_CONTRACT:
      return { ...state, contract: payload.contract };
    case actionTypes.SHOW_WARNING:
      return { ...state, warning: { show: true, message: payload.message } };
    case actionTypes.HIDE_WARNING:
      return { ...state, warning: { ...state.warning, show: false } };
    case actionTypes.SET_CHAIN_ID:
      return { ...state, currentChainId: payload.currentChainId };
    case actionTypes.SET_ETHER_CUR_AMOUNT:
      return { ...state, etherCurPrice: payload.etherCurPrice };
    case actionTypes.SHOW_WALLET_MODAL:
      return { ...state, walletModal: { show: true } };
    case actionTypes.HIDE_WALLET_MODAL:
      return { ...state, walletModal: { show: false } };
    case actionTypes.TOGGLE_WALLET_MODAL:
      return { ...state, walletModal: { show: !state.walletModal?.show } };
    case actionTypes.SET_APPROVED:
      return { ...state, isApproved: payload.isApproved };
    case actionTypes.SET_POOL_FACTORY:
      return { ...state, poolFatory: payload };
    case actionTypes.SET_CORE_POOL:
      return { ...state, corePoolContract: payload };
    case actionTypes.SET_CORE_POOL_ADDRESS:
      return { ...state, corePoolAddress: payload };
    case actionTypes.SET_POOL_ADDRESSES:
      return { ...state, poolAddresses: payload };
    case actionTypes.SET_POOL_CONTRACTS:
      return { ...state, poolContracts: payload };
      case actionTypes.SET_TOKEN_SYMBOL:
        return { ...state, tknSymbol: payload };
    case actionTypes.SET_NETWORKID_FROM_URL:
      return { ...state, networkIdFromURL: payload };
    case actionTypes.SET_DATA_FROM_POOL:
      return { ...state, projectNamePoolName: payload };
    case actionTypes.SET_REALTIME_VALUES:
      return { ...state, realTimeValues: payload };
    case actionTypes.SET_REWARD_DECIMAL_POOL_TOKEN_DECIMAL:
      return { ...state, rewardDecimalPoolTokenDecimal: payload };
    case actionTypes.SET_POOL_DETAILS_FROM_FACTORY:
      return { ...state, poolDetailsFromFactory: payload };
    case actionTypes.SET_ACTION_BASED_DATA:
      return { ...state, actionBasedData: payload}
    case actionTypes.SET_FIRST_LOAD_DATA:
      return { ...state, actionBasedData: {...state.actionBasedData, ...payload}}
    case actionTypes.SET_SECOND_LOAD_DATA:
      return { ...state, actionBasedData: {...state.actionBasedData, ...payload}}
    default:
      return state;
  }
};
